import { CircularProgress, Grid, Paper, Typography } from "@material-ui/core";
import React, { useEffect, useState, useContext } from "react";
import Button from "@mui/material/Button";
import { useLocation, useNavigate } from "react-router-dom";
import Counter from "./Counter";
import Tooltip from "@mui/material/Tooltip";
import "./rms.css";
import moment from "moment";
import { Stack } from "@mui/material";
import routeConstant from "../../../route/compoent/routeConstant";

const QuotesCard = ({
  item,
  index,
  setClicked,
  clicked,
  createQuote,
  objref,
  freightRate,
  quoteArr,
  loadingbutton,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [checkCreateQuote, setCheckCreateQuote] = useState(false);

  const [checkboxValue, setCheckBoxValue] = useState({
    gP20: false,
    gP40: false,
    hQ40: false,
    hQ45: false,
    noR40: false,
  });
  const [counterValue, setCounterValue] = useState({
    gP20: 0,
    gP40: 0,
    hQ40: 0,
    hQ45: 0,
    noR40: 0,
  });
  const objofRates = {
    gP20: item?.gP20,
    gP40: item?.gP40,
    hQ40: item?.hQ40,
    hQ45: item?.hQ45,
    noR40: item?.noR40,
  };

  console.log("quoteArr:", quoteArr);
  const [totalFare, setTotalFare] = useState(0);
  useEffect(() => {
    const ar1 = Object.values(counterValue);
    const arr2 = Object.values(objofRates);
    let sum = 0;
    ar1.forEach((element, index) => {
      sum += element * arr2[index];
    });
    sum = sum.toFixed(2);
    if (sum > 0) setTotalFare(sum);
    else setTotalFare(0);
  }, [counterValue]);
  // console.log(objofRates, "objofRates");
  const checkBoxHandler = (e) => {
    let key = e.target.value;
    let val = e.target.checked;
    setCheckBoxValue({
      ...checkboxValue,
      [key]: val,
    });
    setCounterValue({
      ...counterValue,
      [key]: 0,
    });
  };

  // useEffect(() => {
  //   let sum = Object.values(counterValue).reduce((acc, ele) => acc + ele, 0);
  //   console.log("effect is called ", sum);

  //   if (sum > 0) setCheckCreateQuote(true);
  //   else setCheckCreateQuote(false);
  // }, [counterValue]);

  useEffect(() => {
    // Function to check if the button should be enabled or disabled
    const checkButtonState = () => {
      // Check if any checkbox is true and has a non-zero counter value
      for (const containerType in checkboxValue) {
        if (checkboxValue[containerType] && counterValue[containerType] > 0) {
          setCheckCreateQuote(true);
          return;
        }
      }
      setCheckCreateQuote(false);
    };

    // Call the function initially and whenever checkboxValue or counterValue changes
    checkButtonState();
  }, [checkboxValue, counterValue]);

  return (
    <>
      {location.state.status === "LCL" ? (
        <Grid item xs={12} key={index}>
          <Paper elevation={3} style={{ padding: "0.5rem", margin: "1rem" }}>
            <Grid container>
              <Grid item xs={6} sm={4} md={2}>
                <Typography style={{ fontWeight: "bold", color: "#0069bf" }}>
                  Origin
                </Typography>
                <Typography>
                  {location.state?.origin?.origin ?? "N/A"}(
                  {location.state?.origin?.originCode})
                </Typography>
              </Grid>

              {item?.ipiPrice?.id === 0 ? (
                <Grid item xs={6} sm={4} md={2}>
                  <Typography style={{ fontWeight: "bold", color: "#0069bf" }}>
                    Route
                  </Typography>
                  <Typography>{item?.lclPrice?.routing ?? "N/A"}</Typography>
                </Grid>
              ) : (
                <>
                  <Grid item xs={6} sm={4} md={2}>
                    <Typography
                      style={{ fontWeight: "bold", color: "#0069bf" }}
                    >
                      Route
                    </Typography>
                    <Typography>
                      Via {item?.lclPrice?.destination ?? item?.via ?? "N/A"}
                    </Typography>
                  </Grid>
                </>
              )}

              <Grid item xs={6} sm={4} md={2}>
                <Typography style={{ fontWeight: "bold", color: "#0069bf" }}>
                  Carrier
                </Typography>
                <Typography>
                  {item?.lclPrice?.carrier ?? item?.carrier ?? "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={2}>
                <Typography style={{ fontWeight: "bold", color: "#0069bf" }}>
                  Destination
                </Typography>
                <Typography>
                  {location.state?.destination?.destination ?? "N/A"}(
                  {location.state?.destination?.destinationCode})
                </Typography>
              </Grid>

              <>
                {location.state.status === "LCL" && (
                  <Grid item xs={6} sm={4} md={2}>
                    <Typography
                      style={{ fontWeight: "bold", color: "#0069bf" }}
                    >
                      Rate
                    </Typography>
                    <Typography>USD {item?.total_rate ?? "N/A"}</Typography>
                  </Grid>
                )}
                {location.state.status === "FCL" && (
                  <>
                    <Grid item xs={6} sm={4} md={2}>
                      <Typography
                        style={{ fontWeight: "bold", color: "#0069bf" }}
                      >
                        Transit time
                      </Typography>
                      <Typography>{item?.tT_to_POD ?? "N/A"}</Typography>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sm={4}
                      md={2}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        // maxHeight: "2rem",
                      }}
                    >
                      <div
                        // variant="outlined"
                        // size="small"
                        // onClick={() => {
                        //   if (clicked === index) setClicked(null);
                        //   else setClicked(index);
                        // }}

                        style={{
                          minWidth: "7rem",
                          backgroundColor: "#ffffff",
                          color: "#8cbae8",
                          border: "1px solid #8cbae8",
                          borderRadius: "5px",
                          display: "flex",
                          justifyContent: "center",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                        }}
                      >
                        <span> FCL Rate : </span>{" "}
                        <span style={{ color: "black" }}>
                          {" "}
                          {totalFare == 0 ? ` 0` : ` ${totalFare}`}
                        </span>
                      </div>
                    </Grid>
                  </>
                )}

                <Grid
                  item
                  xs={6}
                  sm={4}
                  md={2}
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    // maxHeight: "2rem",
                  }}
                >
                  <span>
                    <Button
                      disabled={
                        (!checkCreateQuote &&
                          location.state.status === "FCL" &&
                          !(location.state.status === "LCL")) ||
                        freightRate[index]?.buttonDisable
                      }
                      variant="outlined"
                      size="small"
                      style={{ minWidth: "7rem" }}
                      onClick={() => {
                        // setIndexOfButton(index);
                        objref.push(checkboxValue);
                        objref.push(counterValue);
                        objref.push(objofRates);
                        // console.log("createQuote item", item);
                        createQuote(item, index);
                        // setButtonDisable(true);
                      }}
                    >
                      {loadingbutton === index ? (
                        <>
                          <CircularProgress size="0.8rem" />
                        </>
                      ) : (
                        " Create Quote"
                      )}
                    </Button>
                  </span>
                </Grid>
                {freightRate[index]?.buttonDisable && (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: "17px",
                        paddingTop: "10px",
                        fontStyle: "italic",
                      }}
                    >
                      Quote created with ID
                      <span
                        style={{
                          fontWeight: "bold",
                        }}
                      >{` ${quoteArr[index]?.quote_BookingId}`}</span>
                      {`. Book it from the `}
                      <span
                        style={{ cursor: "pointer", color: "blue" }}
                        onClick={() => navigate(routeConstant.LCL)}
                      >
                        Dashboard
                      </span>
                      .
                    </Typography>
                  </div>
                  // <Typography style={{ fontSize: "14px" }}>
                  //   {`Book this quote with ID  ${quoteArr[index]?.quote_BookingId} from dashboard.`}
                  // </Typography>
                )}
              </>
            </Grid>
            <div
              style={
                location.state.status === "FCL"
                  ? {
                      display: "flex",
                      width: "100%",
                      border: "1px solid rgba(25, 118, 210, 0.5)",
                      marginTop: "10px",
                    }
                  : { display: "none" }
              }
            ></div>
            <div
              style={
                location.state.status === "FCL"
                  ? {
                      display: "flex",
                    }
                  : { display: "none" }
              }
              className="justify-content-around "
            >
              <div className="d-flex flex-column">
                <div className="d-flex flex-row gap-2 align-items-center">
                  <input
                    type="checkbox"
                    style={{ height: "18px", width: "18px" }}
                    id="gP20"
                    value="gP20"
                    disabled={item?.gP20 === 0 ? true : false}
                    onClick={(e) => checkBoxHandler(e)}
                  />
                  <div>
                    {/* GP20 :{" "} */}
                    <span
                      style={item?.gP20 !== 0 ? { fontWeight: "bold" } : null}
                    >
                      {item?.gP20 ?? "N/A"}
                    </span>{" "}
                    {/* /Cont. */}
                    /20GP
                  </div>
                </div>
                {checkboxValue.gP20 && (
                  <div>
                    <Counter
                      counterValue={counterValue}
                      setCounterValue={setCounterValue}
                      idv={"gP20"}
                    />
                  </div>
                )}
              </div>
              <div className="d-flex flex-column">
                <div className="d-flex flex-row gap-2 align-items-center">
                  <input
                    type="checkbox"
                    style={{ height: "18px", width: "18px" }}
                    id="gP40"
                    value="gP40"
                    onClick={(e) => checkBoxHandler(e)}
                    disabled={item?.gP40 === 0 ? true : false}
                  />
                  <div>
                    {/* GP40 :{" "} */}
                    <span
                      style={item?.gP40 !== 0 ? { fontWeight: "bold" } : null}
                    >
                      {item?.gP40 ?? "N/A"}
                    </span>{" "}
                    {/* /Cont. */}
                    /40GP
                  </div>
                </div>
                {checkboxValue.gP40 && (
                  <div>
                    <Counter
                      counterValue={counterValue}
                      setCounterValue={setCounterValue}
                      idv={"gP40"}
                    />
                  </div>
                )}
              </div>
              <div className="d-flex flex-column">
                <div className="d-flex flex-row gap-2 align-items-center">
                  <input
                    type="checkbox"
                    style={{ height: "18px", width: "18px" }}
                    id="hQ40"
                    value="hQ40"
                    onClick={(e) => checkBoxHandler(e)}
                    disabled={item?.hQ40 === 0 ? true : false}
                  />
                  <div>
                    {/* HQ40 :{" "} */}
                    <span
                      style={item?.hQ40 !== 0 ? { fontWeight: "bold" } : null}
                    >
                      {item?.hQ40 ?? "N/A"}
                    </span>{" "}
                    {/* /Cont. */}
                    /40HQ
                  </div>
                </div>
                {checkboxValue.hQ40 && (
                  <div>
                    <Counter
                      counterValue={counterValue}
                      setCounterValue={setCounterValue}
                      idv={"hQ40"}
                    />
                  </div>
                )}
              </div>
              <div className="d-flex flex-column">
                <div className="d-flex flex-row gap-2 align-items-center">
                  <input
                    type="checkbox"
                    id="hQ45"
                    style={{ height: "18px", width: "18px" }}
                    value="hQ45"
                    onClick={(e) => checkBoxHandler(e)}
                    disabled={item?.hQ45 === 0 ? true : false}
                  />
                  <div>
                    {/* HQ45 :{" "} */}
                    <span
                      style={item?.hQ45 !== 0 ? { fontWeight: "bold" } : null}
                    >
                      {item?.hQ45 ?? "N/A"}
                    </span>{" "}
                    {/* /Cont. */}
                    /45HQ
                  </div>
                </div>
                {checkboxValue.hQ45 && (
                  <div>
                    <Counter
                      counterValue={counterValue}
                      setCounterValue={setCounterValue}
                      idv={"hQ45"}
                    />
                  </div>
                )}
              </div>
              <div className="d-flex flex-column">
                <div className="d-flex flex-row gap-2 align-items-center">
                  <input
                    type="checkbox"
                    style={{ height: "18px", width: "18px" }}
                    id="noR40"
                    value="noR40"
                    onClick={(e) => checkBoxHandler(e)}
                    disabled={item?.noR40 === 0 ? true : false}
                  />
                  <div>
                    {/* NOR40 :{" "} */}
                    <span
                      style={item?.noR40 !== 0 ? { fontWeight: "bold" } : null}
                    >
                      {item?.noR40 ?? "N/A"}
                    </span>{" "}
                    {/* /Cont. */}
                    /40NOR
                  </div>
                </div>
                {checkboxValue.noR40 && (
                  <div>
                    <Counter
                      counterValue={counterValue}
                      setCounterValue={setCounterValue}
                      idv={"noR40"}
                    />
                  </div>
                )}
              </div>
            </div>
          </Paper>
        </Grid>
      ) : (
        <Grid item xs={12} key={index}>
          <Paper elevation={3} style={{ padding: "0.5rem", margin: "1rem" }}>
            <Grid container>
              <Grid item xs={6} sm={4} md={2}>
                <Typography style={{ fontWeight: "bold", color: "#0069bf" }}>
                  Origin
                </Typography>
                <Typography>
                  {location.state?.origin?.origin ?? "N/A"}
                  {/* (
                  {location.state?.origin?.originCode}) */}
                </Typography>
              </Grid>

              {item?.ipiPrice?.id === 0 ? (
                <Grid item xs={6} sm={4} md={1}>
                  <Typography style={{ fontWeight: "bold", color: "#0069bf" }}>
                    Route
                  </Typography>
                  <Typography>{item?.routing ?? "N/A"}</Typography>
                </Grid>
              ) : (
                <>
                  <Grid item xs={6} sm={4} md={1}>
                    <Typography
                      style={{ fontWeight: "bold", color: "#0069bf" }}
                    >
                      Route
                    </Typography>
                    <Typography>Via {item?.routing ?? "N/A"}</Typography>
                  </Grid>
                </>
              )}

              <Grid item xs={6} sm={4} md={1} style={{ paddingLeft: "15px" }}>
                <Typography style={{ fontWeight: "bold", color: "#0069bf" }}>
                  Carrier
                </Typography>
                <Typography>
                  {item?.lclPrice?.carrier ?? item?.carrier ?? "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={4} md={2}>
                <Typography style={{ fontWeight: "bold", color: "#0069bf" }}>
                  Destination
                </Typography>
                <Typography>
                  {location.state?.destination?.destination ?? "N/A"}
                  {/* (
                  {location.state?.destination?.destinationCode}) */}
                </Typography>
              </Grid>

              <>
                {location.state.status === "LCL" && (
                  <Grid item xs={6} sm={4} md={2}>
                    <Typography
                      style={{ fontWeight: "bold", color: "#0069bf" }}
                    >
                      Rate
                    </Typography>
                    <Typography>USD {item?.total_rate ?? "N/A"}</Typography>
                  </Grid>
                )}
                {location.state.status === "FCL" && (
                  <>
                    <Grid item xs={6} sm={4} md={2}>
                      <Typography
                        style={{ fontWeight: "bold", color: "#0069bf" }}
                      >
                        Transit time
                      </Typography>

                      <Typography>{item?.tT_to_POD ?? "N/A"} Day(s)</Typography>
                    </Grid>

                    <Grid
                      item
                      xs={6}
                      sm={4}
                      md={2}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        flexDirection: "column",
                        // maxHeight: "2rem",
                      }}
                    >
                      <Typography
                        style={{ fontWeight: "bold", color: "#0069bf" }}
                      >
                        {" "}
                        FCL Rate :
                      </Typography>

                      <Typography
                        style={
                          totalFare
                            ? {
                                fontSize: "18px",
                                fontWeight: "bold",
                              }
                            : {}
                        }
                      >
                        {totalFare}
                      </Typography>
                      {/* <div style={{ fontSize: "18px" }}>
                        <span>Validity : </span>{" "}
                        <span class="blinking-text">
                          {moment(item?.expiringDate).format("MM/DD/YYYY") ??
                            "N/A"}
                        </span>
                      </div> */}
                      {/* <div
                        style={{
                          minWidth: "7rem",
                          backgroundColor: "#ffffff",
                          color: "#8cbae8",
                          border: "1px solid #8cbae8",
                          borderRadius: "5px",
                          display: "flex",
                          justifyContent: "center",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                        }}
                      > */}
                      {/* <p style={{ fontWeight: "bold", color: "#0069bf" }}>
                          {" "}
                          FCL Rate :{" "}
                        </p>{" "}
                        <p style={{ color: "black" }}>
                          {" "}
                          {totalFare === 0 ? <p>0</p> : <p>` ${totalFare}`</p>}
                        </p> */}
                      {/* </div> */}
                    </Grid>
                  </>
                )}

                <Grid
                  item
                  xs={6}
                  sm={4}
                  md={2}
                  style={{
                    display: "flex",
                    flexDirection: "col",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    // maxHeight: "2rem",
                  }}
                >
                  <Stack direction={"column"}>
                    <div
                    // style={{ fontSize: "12px" }}
                    >
                      <Grid container spacing={0}>
                        <Grid
                          item
                          lg={6}
                          sx={{
                            padding: "1rem",
                          }}
                        >
                          <Typography
                            style={{
                              fontWeight: "bold",
                              color: "#0069bf",
                              paddingRight: "0.8rem",
                            }}
                          >
                            Validity{" "}
                          </Typography>
                        </Grid>
                        <Grid item lg={6}>
                          <p
                            // class="blinking-text"
                            style={{
                              fontSize: "12px",
                              fontWeight: "bold",
                              paddingTop: "0.2rem",
                              paddingBottom: "0px",
                              marginBottom: "0px",
                              color: "green",
                            }}
                          >
                            {moment(item?.effectiveDate).format("MM/DD/YYYY") ??
                              "N/A"}
                          </p>
                          <p
                            style={{
                              fontSize: "12px",
                              padding: "0px !important",
                              marginBottom: "0px",
                              textAlign: "center",
                            }}
                          >
                            to
                          </p>
                          <p
                            style={{
                              fontSize: "12px",
                              fontWeight: "bold",
                              color: "red",
                            }}
                          >
                            {moment(item?.expiringDate).format("MM/DD/YYYY") ??
                              "N/A"}
                          </p>
                        </Grid>
                      </Grid>{" "}
                    </div>
                    <div>
                      {!freightRate[index]?.buttonDisable ? (
                        <span>
                          <Button
                            disabled={
                              !checkCreateQuote &&
                              location.state.status === "FCL" &&
                              !(location.state.status === "LCL")
                            }
                            variant="outlined"
                            size="small"
                            style={{ minWidth: "7rem" }}
                            onClick={() => {
                              // setIndexOfButton(index);
                              objref.push(checkboxValue);
                              objref.push(counterValue);
                              objref.push(objofRates);
                              // console.log("createQuote item", item);
                              createQuote(item, index);
                              objref = [];
                              console.log(objref, "objrefggsrgr");
                              // setButtonDisable(true);
                            }}
                          >
                            {loadingbutton === index ? (
                              <>
                                <CircularProgress size="0.8rem" />
                              </>
                            ) : (
                              " Create Quote"
                            )}
                          </Button>
                        </span>
                      ) : null}
                    </div>
                  </Stack>
                </Grid>
              </>
            </Grid>
            <div
              style={
                location.state.status === "FCL"
                  ? {
                      display: "flex",
                      width: "100%",
                      border: "1px solid rgba(25, 118, 210, 0.5)",
                      marginTop: "10px",
                    }
                  : { display: "none" }
              }
            ></div>
            <div
              style={
                location.state.status === "FCL"
                  ? {
                      display: "flex",
                    }
                  : { display: "none" }
              }
              className="justify-content-around "
            >
              <div className="d-flex flex-column">
                <div className="d-flex flex-row gap-2 align-items-center">
                  <input
                    type="checkbox"
                    style={{ height: "18px", width: "18px" }}
                    id="gP20"
                    value="gP20"
                    disabled={
                      item?.gP20 === 0 || freightRate[index]?.buttonDisable
                        ? true
                        : false
                    }
                    onClick={(e) => checkBoxHandler(e)}
                  />
                  <div>
                    {/* GP20 :{" "} */}
                    <span
                      style={item?.gP20 !== 0 ? { fontWeight: "bold" } : null}
                    >
                      {item?.gP20 ?? "N/A"}
                    </span>{" "}
                    {/* /Cont. */}
                    /20GP
                  </div>
                </div>
                {checkboxValue.gP20 && (
                  <div>
                    <Counter
                      counterValue={counterValue}
                      setCounterValue={setCounterValue}
                      idv={"gP20"}
                      qouteCreated={freightRate[index]?.buttonDisable}
                    />
                  </div>
                )}
              </div>
              <div className="d-flex flex-column">
                <div className="d-flex flex-row gap-2 align-items-center">
                  <input
                    type="checkbox"
                    style={{ height: "18px", width: "18px" }}
                    id="gP40"
                    value="gP40"
                    onClick={(e) => checkBoxHandler(e)}
                    disabled={
                      item?.gP40 === 0 || freightRate[index]?.buttonDisable
                        ? true
                        : false
                    }
                  />
                  <div>
                    {/* GP40 :{" "} */}
                    <span
                      style={item?.gP40 !== 0 ? { fontWeight: "bold" } : null}
                    >
                      {item?.gP40 ?? "N/A"}
                    </span>{" "}
                    {/* /Cont. */}
                    /40GP
                  </div>
                </div>
                {checkboxValue.gP40 && (
                  <div>
                    <Counter
                      counterValue={counterValue}
                      setCounterValue={setCounterValue}
                      idv={"gP40"}
                      qouteCreated={freightRate[index]?.buttonDisable}
                    />
                  </div>
                )}
              </div>
              <div className="d-flex flex-column">
                <div className="d-flex flex-row gap-2 align-items-center">
                  <input
                    type="checkbox"
                    style={{ height: "18px", width: "18px" }}
                    id="hQ40"
                    value="hQ40"
                    onClick={(e) => checkBoxHandler(e)}
                    disabled={
                      item?.hQ40 === 0 || freightRate[index]?.buttonDisable
                        ? true
                        : false
                    }
                  />
                  <div>
                    {/* HQ40 :{" "} */}
                    <span
                      style={item?.hQ40 !== 0 ? { fontWeight: "bold" } : null}
                    >
                      {item?.hQ40 ?? "N/A"}
                    </span>{" "}
                    {/* /Cont. */}
                    /40HQ
                  </div>
                </div>
                {checkboxValue.hQ40 && (
                  <div>
                    <Counter
                      counterValue={counterValue}
                      setCounterValue={setCounterValue}
                      idv={"hQ40"}
                      qouteCreated={freightRate[index]?.buttonDisable}
                    />
                  </div>
                )}
              </div>
              <div className="d-flex flex-column">
                <div className="d-flex flex-row gap-2 align-items-center">
                  <input
                    type="checkbox"
                    id="hQ45"
                    style={{ height: "18px", width: "18px" }}
                    value="hQ45"
                    onClick={(e) => checkBoxHandler(e)}
                    disabled={
                      item?.hQ45 === 0 || freightRate[index]?.buttonDisable
                        ? true
                        : false
                    }
                  />
                  <div>
                    {/* HQ45 :{" "} */}
                    <span
                      style={item?.hQ45 !== 0 ? { fontWeight: "bold" } : null}
                    >
                      {item?.hQ45 ?? "N/A"}
                    </span>{" "}
                    {/* /Cont. */}
                    /45HQ
                  </div>
                </div>
                {checkboxValue.hQ45 && (
                  <div>
                    <Counter
                      counterValue={counterValue}
                      setCounterValue={setCounterValue}
                      idv={"hQ45"}
                      qouteCreated={freightRate[index]?.buttonDisable}
                    />
                  </div>
                )}
              </div>
              <div className="d-flex flex-column">
                <div className="d-flex flex-row gap-2 align-items-center">
                  <input
                    type="checkbox"
                    style={{ height: "18px", width: "18px" }}
                    id="noR40"
                    value="noR40"
                    onClick={(e) => checkBoxHandler(e)}
                    disabled={
                      item?.noR40 === 0 || freightRate[index]?.buttonDisable
                        ? true
                        : false
                    }
                  />
                  <div>
                    {/* NOR40 :{" "} */}
                    <span
                      style={item?.noR40 !== 0 ? { fontWeight: "bold" } : null}
                    >
                      {item?.noR40 ?? "N/A"}
                    </span>{" "}
                    {/* /Cont. */}
                    /40NOR
                  </div>
                </div>
                {checkboxValue.noR40 && (
                  <div>
                    <Counter
                      counterValue={counterValue}
                      setCounterValue={setCounterValue}
                      idv={"noR40"}
                      qouteCreated={freightRate[index]?.buttonDisable}
                    />
                  </div>
                )}
              </div>
            </div>
            {freightRate[index]?.buttonDisable ? (
              <Typography
                style={{
                  fontSize: "17px",
                  paddingTop: "10px",
                  fontStyle: "italic",
                }}
                align="right"
              >
                Quote created with ID
                <span
                  style={{
                    fontWeight: "bold",
                  }}
                >{` ${quoteArr[index]?.quote_BookingId}`}</span>
                {`. Book it from the `}
                <span
                  style={{ cursor: "pointer", color: "blue" }}
                  onClick={() => navigate(routeConstant.FCL)}
                >
                  Dashboard
                </span>
                .
              </Typography>
            ) : null}
          </Paper>
        </Grid>
      )}
    </>
  );
};

export default QuotesCard;
